import { numFormat } from "./numFormat";

export function goodsLocationQuantity(input: any): string {
  const formattedTotalQuantity = numFormat(input.totalQuantity);
  return `${formattedTotalQuantity}`;
}

export function goodsLocationsOverview(input: any): string {
  let returnedString = '';
  if (!input) return returnedString;
  Object.keys(input).reverse().forEach(location => {
    returnedString += `${location}: ${goodsLocationQuantity(input[location])}\n`;
  });
  return returnedString;
}
